// import Berufsgenerator from './Berufsgenerator'
import React from 'react'
import ComingSoon from 'components/Student/ComingSoon'

const Berufsgenerator = () => {
  return <ComingSoon title='Kommt bald!' subtitle='Dieses Feature wird in Zukunft verfügbar sein'/>
}

export default Berufsgenerator